import { Component, computed, input } from "@angular/core";
import { FieldTree } from "@angular/forms/signals";
import { ExpandableMinMaxFilterComponent, MinMaxFilterConfig } from "src/app/shared-components/expandable-min-max-filter/expandable-min-max-filter.component";
import { TimeOnMarketFilterModel } from "./search-filter-timeonmarket.model";

@Component({
    selector: "search-filter-timeonmarket",
    imports: [ExpandableMinMaxFilterComponent],
    templateUrl: "./search-filter-timeonmarket.component.html",
    styleUrl: "./search-filter-timeonmarket.component.scss",
})
export class SearchFilterTimeOnMarketComponent {
    filterForm = input.required<FieldTree<TimeOnMarketFilterModel>>();

    showTooltip = false;

    timePeriodTooltip = {
        show: false,
        header: "Omsetningshastighet",
        body: "NB! Tinglysninger vises med 0 dagers omsetningshastighet. Hvis man ønsker å ekskludere disse fra utvalget må man ta av filteret Vis tinglysninger.",        
    };

    protected filterConfig = computed<MinMaxFilterConfig<TimeOnMarketFilterModel>>(() => ({
        filterForm: this.filterForm,
        title: "Omsetningshastighet",
        fromFieldAccessor: (form) => form.timeOnMarketFrom,
        toFieldAccessor: (form) => form.timeOnMarketTo,
        expandedAccessor: (form) => form.expanded,
        fromFieldId: "timeOnMarketFrom",
        toFieldId: "timeOnMarketTo",
        cssClass: "price",
        tooltip: this.timePeriodTooltip,
    }));
}
